module.exports = __webpack_public_path__ + "img/jingdong.35d74a91.jpeg";